import React from "react";
import CustomModal from "../../../components/common/general/CustomModal/CustomModal";
import JourneyFormContainer from "../JourneyFormContainer/JourneyFormContainer";

const JourneyFormModalContainer = ({ visible, onClose, onSubmit }) => {
  return (
    <CustomModal visible={visible} onRequestClose={onClose} showCloseButton={true} title="Create A Journey">
      <JourneyFormContainer onSubmit={onSubmit} onComplete={onClose} />
    </CustomModal>
  );
};

export default JourneyFormModalContainer;
